export default __webpack_public_path__ + "static/cta_bg-6358a3c546c1a0cdc7e55faaa4e1b62b.jpg";